// Shared plan data — used by PricingCards and ComparisonTable
export const PLANS = [
  {
    id: "trial",
    name: "FREE TRIAL",
    price: "₹0",
    period: "30 days",
    suitableFor: "Evaluation",
    cta: "Start Free Trial",
    ctaRoute: "/signup",
    features: [
      "Full ERP Access",
      "Unlimited Transactions",
      "Multi Branch",
      "POS Billing",
      "Inventory",
      "Purchase",
      "Sales",
      "Production",
      "Reports",
      "AI Reports",
      "Mobile Access",
      "Tally Integration",
      "Email Support",
      "Cloud Hosting Included",
      "No Credit Card Required",
    ],
  },
  {
    id: "starter",
    name: "STARTER",
    price: "₹2,999",
    period: "month",
    suitableFor: "Single Branch Businesses",
    cta: "Choose Starter",
    ctaRoute: "/signup",
    features: [
      "Everything in Trial",
      "1 Branch",
      "Up to 5 Users",
      "POS Billing",
      "Offline POS",
      "Inventory",
      "Purchase",
      "Sales",
      "Barcode Support",
      "GST",
      "Basic Reports",
      "Tally Integration",
      "Daily Backup",
      "Email Support",
    ],
  },
  {
    id: "silver",
    name: "SILVER",
    price: "₹5,999",
    period: "month",
    suitableFor: "Growing Businesses",
    cta: "Choose Silver",
    ctaRoute: "/signup",
    highlighted: true,
    features: [
      "Up to 5 Branches",
      "20 Users",
      "Multi Branch Stock Transfer",
      "Production Module",
      "Bakery Module",
      "Manufacturing",
      "Wholesale",
      "Advanced Inventory",
      "Advanced Reports",
      "AI Reports",
      "Mobile App",
      "Tally Integration",
      "Priority Support",
      "Daily Backup",
      "API Access",
    ],
  },
  {
    id: "gold",
    name: "GOLD",
    price: "₹9,999",
    period: "month",
    suitableFor: "Large Businesses",
    cta: "Choose Gold",
    ctaRoute: "/signup",
    features: [
      "Unlimited Branches",
      "Unlimited Users",
      "Cloud ERP",
      "Offline POS",
      "AI Analytics",
      "Sales Forecast",
      "Inventory Forecast",
      "Purchase Assistant",
      "Production Planning",
      "Role Based Security",
      "Multi Company",
      "API Integration",
      "Webhooks",
      "WhatsApp Integration",
      "Mobile App",
      "Priority Support",
      "Dedicated Account Manager",
      "Free Onboarding",
      "Training",
    ],
  },
  {
    id: "enterprise",
    name: "ENTERPRISE",
    price: "Custom",
    period: null,
    suitableFor: "Franchises & Custom Deployments",
    cta: "Contact Sales",
    ctaRoute: "/partner",
    features: [
      "Everything in Gold",
      "Franchise Management",
      "White-Label Deployment",
      "Custom Integrations",
      "Dedicated Infrastructure",
      "Custom SLA",
      "On-site Training",
      "24/7 Priority Support",
    ],
  },
];

// Feature-comparison matrix — value can be true, false, or a string (e.g. branch limit)
export const COMPARISON_ROWS = [
  { feature: "Cloud ERP", trial: true, starter: true, silver: true, gold: true },
  { feature: "Offline POS", trial: true, starter: true, silver: true, gold: true },
  { feature: "Inventory", trial: true, starter: true, silver: true, gold: true },
  { feature: "Purchase", trial: true, starter: true, silver: true, gold: true },
  { feature: "Sales", trial: true, starter: true, silver: true, gold: true },
  { feature: "Production", trial: true, starter: false, silver: true, gold: true },
  { feature: "Manufacturing", trial: true, starter: false, silver: true, gold: true },
  { feature: "Bakery", trial: true, starter: false, silver: true, gold: true },
  { feature: "Wholesale", trial: true, starter: false, silver: true, gold: true },
  { feature: "Accounting", trial: true, starter: true, silver: true, gold: true },
  { feature: "Tally Integration", trial: true, starter: true, silver: true, gold: true },
  { feature: "AI Reports", trial: true, starter: false, silver: true, gold: true },
  { feature: "Mobile App", trial: true, starter: false, silver: true, gold: true },
  { feature: "Branch Limit", trial: "Unlimited", starter: "1", silver: "5", gold: "Unlimited" },
  { feature: "User Limit", trial: "Unlimited", starter: "5", silver: "20", gold: "Unlimited" },
  { feature: "Support", trial: "Email", starter: "Email", silver: "Priority", gold: "Dedicated" },
  { feature: "API", trial: false, starter: false, silver: true, gold: true },
  { feature: "Backup", trial: true, starter: true, silver: true, gold: true },
];
